const LABELS = {
  EMAIL: 'Email',
  EMAIL_DATA_TEST_ID: 'input-email'
};

export default LABELS;
